import { QuestionFilter, questionStatus } from 'types'

const allowedStatuses: questionStatus[] = [
  'created',
  'toReview',
  'inReview',
  'reviewed',
  'updated',
  'approved',
  'stored',
  'deleted',
]

export const getRevisionLinkFilters = (
  search: string,
  reviewerId?: string
): QuestionFilter | undefined => {
  if (!reviewerId) return undefined

  const requestedStatus = new URLSearchParams(search).get('status') as questionStatus | null
  if (!requestedStatus || !allowedStatuses.includes(requestedStatus)) return undefined

  return {
    limit: 10,
    offset: 0,
    reviewer: reviewerId,
    status: requestedStatus,
    topics: [],
  }
}
